// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2Cxvp","loaderOuter":"PageOverlayLoader_loaderOuter__1Xu3C"};